import { render, staticRenderFns } from "./ModalDadosSegurado.vue?vue&type=template&id=5b4a23b8"
import script from "./ModalDadosSegurado.vue?vue&type=script&lang=js"
export * from "./ModalDadosSegurado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports